"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RENTAL_USER_ROLES = void 0;
exports.RENTAL_USER_ROLES = Object.freeze({
    PRIMARY: 'primary',
    TENANT: 'tenant'
});
